import { Message } from '../components/MessageBoard';

export const sampleMessages: Message[] = [
    {
        id: '1',
        name: '报名者',
        location: '',
        message: '在关注到您的计划之前我有看到过这样的形式在国外进行，我真的非常喜欢并支持，这是有关记录的接力，我们彼此分享着彼此的故事，我很希望能有机会参与到这次的活动，本人目前是云南大学的学生，我有时间可以等，平时也很喜欢拍摄，希望可以入选，选上我就去雨崩哈哈！',
        timestamp: '2024-08-20 14:30',
        status: 'approved'
    },
    {
        id: '2',
        name: '报名者',
        location: '',
        message: '胶片是温暖记忆和生命力的缓慢回流 希望博主举办这个活动一切顺利！一定会非常有意义。',
        timestamp: '2024-08-20 15:45',
        status: 'approved'
    },
    {
        id: '3',
        name: '报名者',
        location: '',
        message: '照片可以定格时间，但胶卷带给我的是可以重回那段时间的力量',
        timestamp: '2024-08-20 16:20',
        status: 'approved'
    },
    {
        id: '4',
        name: '报名者',
        location: ' ',
        message: '自己用数码相机拍过好几年的照片了，不过还是随手记录那种比较多啦，拿起相机就什么都想拍一拍。一直对胶片很感兴趣可惜现在胶卷很贵也一直没有尝试，只有一次在公园有路人问能不能帮忙拍一下（用她们的一次性胶片相机）很感谢这种活动！希望有机会能够拍摄～如果十月前可能会拍一些校园的内容',
        timestamp: '2024-08-20 17:10',
        status: 'approved'
    },
    {
        id: '5',
        name: '报名者',
        location: '',
        message: '哈哈，没有什么想说的，这么近，这么美，周末拍河北😆',
        timestamp: '2024-08-20 18:00',
        status: 'approved'
    },
    {
        id: '6',
        name: '报名者',
        location: '',
        message: '我是一位小学老师，从我的视角出发能看到一些很可爱又有趣的学生瞬间，而我也很喜欢在生活里发现那些有趣的小角落。我自己也拍过胶片，彩负，电影卷，黑白，反转都拍过。',
        timestamp: '2024-08-20 19:15',
        status: 'approved'
    },
    {
        id: '7',
        name: '报名者',
        location: '',
        message: '胶片是给自己未来的一个惊喜回忆，延续着我对摄影的期待；或者说，是对生活的期待。胶片给予了每次拍摄二次判断，时常会出现"如果手里拿的是数码相机肯定就拍一张"的情况，但只有胶片相机在手时，即便是相机开关按下了许多次也终究没能按下快门一次。 所以，在社交平台or朋友圈中呈现的是"精挑细选"后的相片，也仅代表着我对生活的观察。我不能明确说出胶片与数码在屏幕观看上的具体区别，但就像大家所看到的，胶片总是很特别，那种特质无法言说。',
        timestamp: '2024-08-20 20:30',
        status: 'approved'
    },
    {
        id: '8',
        name: '报名者',
        location: '',
        message: '我想拍摄的不是传统意义上的青岛，我想拍摄青岛西海岸新区的景象，这是我生长的地方，从个人的情绪角度来说，它其实和青岛挺割裂的。我出生于04年，我们这一代从前大多不认为自己是青岛人，更多是在说"胶南人"。后来国家更改行政规划，将我们的家乡划为青岛西海岸新区，我们的生活有了翻天覆地的变化。虽然一路上筚路蓝缕，但也仍然存在区内发展不均衡的问题。希望能通过我的镜头，把我的家乡优美和不足的地方都展现出来。',
        timestamp: '2024-08-20 21:00',
        status: 'approved'
    }
];

export const pendingMessages: Message[] = [
    {
        id: '9',
        name: '新报名者',
        location: '待审核',
        message: '这是一条待审核的留言...',
        timestamp: '2024-08-20 22:00',
        status: 'pending'
    }
];

